<template>
    <div>
        <table width="100%">
            <tr>
                <td colspan="2" style="text-align:center;padding-bottom:10px"> <span class="plan-name">{{ getPlanName() }}<span> <span class="plan-status">{{ getDisplayPlanState() }}</span></td>
            </tr>
            <div v-if="basicContract.billingType != 2">
                <tr>
                    <td> {{ getMonthlyPrice() }} </td>
                    <td rowspan="2" style="vertical-align:middle;padding-left:40px">
                        <button class="transparent-button" type="button" v-on:click="$emit('showDetail')"><span class="normal-command-text" v-t="'message.action_talk_detail'"></span></button>
                    </td>
                </tr>
                <tr>
                    <td> {{ getYearlyPrice() }} </td>
                </tr>
            </div>
            <div v-else>
                <tr>
                    <td>
                        <button class="transparent-button" type="button" v-on:click="$emit('showDetail')"><span class="normal-command-text" v-t="'message.action_talk_detail'"></span></button>
                    </td>
                </tr>
            </div>
            <tr>
                <td colspan="2" class="plan-description">
                    {{ getDescriptionOfPlan() }} 
                    <br/>
                    <span  v-if="planType == Const.LICENSE_PLAN_LIVE_LITE" v-t="'message.desc_live_lite_additional'" style="color: red;"></span>
                </td>
            </tr>
            <tr v-if="basicContract.billingType != 2">
                <td v-if="!alreadyPurchased" colspan="2" class="purchase-button">
                    <el-button v-if="existPendingProcess" class="disable-command-button" style="width:250px" v-t="'message.button_purchase'"></el-button>
                    <el-button v-else-if="planType == Const.LICENSE_PLAN_LIVE_LITE" class="disable-command-button" style="width:250px" v-t="'message.button_purchase'"></el-button>
                    <el-button v-else class="enable-command-button" v-on:click="purchasePlan()" style="width:250px" v-t="'message.button_purchase'"></el-button>
                </td>
                <td v-else-if="isCurrentPlan()" colspan="2" class="purchase-button">
                    <el-button class="disable-command-button" style="width:250px" v-t="'message.action_change_plan'"></el-button>
                </td>
                <td v-else colspan="2" class="purchase-button">
                    <el-button v-if="(registeredPlanChangeOperation == null) && !existPendingProcess" class="enable-command-button" style="width:250px" v-on:click="purchasePlan()" v-t="'message.action_change_plan'"></el-button>
                    <el-button v-else-if="isRegisteredDowngrade()" class="enable-command-button" style="width:250px" v-on:click="cancelDowngrade()" v-t="'message.action_cancel_downgrade'"></el-button>
                    <el-button v-else class="disable-command-button" style="width:250px" v-t="'message.action_change_plan'"></el-button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data () {
        return {
            Const: {
                LICENSE_PLAN_LIVE_LITE: constants.LICENSE_PLAN_LIVE_LITE,
            }
        };
    },
    methods: {
        purchasePlan() {
            this.$emit('purchasePlan', this.planType );
        },
        cancelDowngrade() {
            this.$emit('cancelDowngrade', this.registeredPlanChangeOperation );
        },
        getPlanName() {
            switch(this.planType) {
                case constants.LICENSE_PLAN_TALK_LITE:
                    return "Talk Lite";
                case constants.LICENSE_PLAN_TALK_ENT:
                    return "Talk Enterprise";
                case constants.LICENSE_PLAN_LIVE_LITE:
                    return "Livecast Lite";
                case constants.LICENSE_PLAN_LIVE_ENT:
                    return "Livecast Enterprise";
            }
        },
        getMonthlyPrice() {
            if (typeof this.priceOfPlan === "undefined") {
                return;
            }
            return  commonUtil.getMessageText(this.$i18n,"item_monthly_price1") + commonUtil.getMessageText(this.$i18n,"unit_monthly_price").replace("{price}", this.getDisplayPrice(this.priceOfPlan.monthPrice));
        },
        getYearlyPrice() {
            if (typeof this.priceOfPlan === "undefined") {
                return;
            }
            return commonUtil.getMessageText(this.$i18n,"item_yearly_price1") + commonUtil.getMessageText(this.$i18n,"unit_yearly_price").replace("{price}", this.getDisplayPrice(this.priceOfPlan.yearPrice));
        },
        getDisplayPrice(price) {
            return commonUtil.getDisplayPrice(this.currencyYen, price);
        },
        getDescriptionOfPlan() {
            switch(this.planType) {
                case constants.LICENSE_PLAN_TALK_LITE:
                    return commonUtil.getMessageText(this.$i18n,"desc_talk_lite");
                case constants.LICENSE_PLAN_TALK_ENT:
                    return commonUtil.getMessageText(this.$i18n,"desc_talk_ent");
                case constants.LICENSE_PLAN_LIVE_LITE:
                    return commonUtil.getMessageText(this.$i18n,"desc_live_lite");
                case constants.LICENSE_PLAN_LIVE_ENT:
                    return commonUtil.getMessageText(this.$i18n,"desc_live_ent");
            }
        },
        getDisplayPlanState() {
            if (this.basicContract.planType == this.planType) {
                if (this.basicContract.state == constants.CONTRACT_TERMINATE) {
                    return commonUtil.getMessageText(this.$i18n,"item_end_of_use");
                } else {
                    return commonUtil.getMessageText(this.$i18n,"item_value_used");
                }
            } else {
                if (this.isRegisteredDowngrade()) {
                    return commonUtil.getMessageText(this.$i18n,"item_downgrade_has_registered");
                } else {
                    return "";
                }
            }
        },
        getDisplayPlanState() {
            if (this.basicContract.planType == this.planType) {
                if (this.basicContract.state == constants.CONTRACT_TERMINATE) {
                    return commonUtil.getMessageText(this.$i18n,"item_end_of_use");
                } else {
                    return commonUtil.getMessageText(this.$i18n,"item_value_used");
                }
            } else {
                if (this.isRegisteredDowngrade()) {
                    return commonUtil.getMessageText(this.$i18n,"item_downgrade_has_registered");
                } else {
                    return "";
                }
            }
        },
        isCurrentPlan() {
            if (this.basicContract.planType == this.planType) {
                return true;
            } else {
                return false;
            }
        },
        isRegisteredDowngrade() {
            if (this.registeredPlanChangeOperation == null) {
                return false;
            }
            switch(this.registeredPlanChangeOperation.operationCode) {
                case constants.DEFERRED_TE_TO_TL:
                case constants.DEFERRED_LL_TO_TL:
                case constants.DEFERRED_LE_TO_TL:
                    if (this.planType == constants.LICENSE_PLAN_TALK_LITE) {
                        return true;
                    } else {
                        return false;
                    }
                    break;
                case constants.DEFERRED_LL_TO_TE:
                case constants.DEFERRED_LE_TO_TE:
                    if (this.planType == constants.LICENSE_PLAN_TALK_ENT) {
                        return true;
                    } else {
                        return false;
                    }
                    break;
                case constants.DEFERRED_LE_TO_LL:
                case constants.DEFERRED_TE_TO_LL:
                    if (this.planType == constants.LICENSE_PLAN_LIVE_LITE) {
                        return true;
                    } else {
                        return false;
                    }
                    break;
                default:
                    return false;
            }
        }
    },
    created: function() {
    },
    mounted: function() {
    },
    computed: {
    },
    watch: {
    },
    components: {
    },
    props: [ 'basicContract' , 'planType' , 'newPurchase' , 'alreadyPurchased' , 'registeredPlanChangeOperation' , 'existPendingProcess' , 'priceOfPlan' , 'currencyYen' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.plan-name {
    font-size: 18px;
    font-weight: bolder;
}
.plan-status {
    padding-left: 20px;
    font-size: 14px;
    color: #d55169;
    font-weight: bolder;
}
.plan-description {
    height: 90px;
    padding-top: 10px;
    font-size: 14px;
    vertical-align: top;
}
.purchase-button {
    padding-top: 20px;
    padding-bottom: 10px;
    text-align: center;
}
</style>
